import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=b43d7f7e&scoped=true"
var script = {}
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=b43d7f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43d7f7e",
  null
  
)

export default component.exports